import { CONSTANTS } from '../config/constants';
import MapObject from '../models/map_object';

document.addEventListener('DOMContentLoaded', () => {
	if (document.getElementById('destination-map')) {
		let map = new mapboxgl.Map({
			container: 'destination-map',
			style: CONSTANTS.map_style,
			center: CONSTANTS.map_center,
			zoom: 16,
			minZoom: 13,
			maxZoom: 20,
			maxBounds: [
				[-89.6, 42.96],
				[-89.3, 43.2],
			],
			scrollZoom: true,
			pitchWithRotate: false,
			dragRotate: false,
			hash: false,
			trackResize: true,
		});
		W.map = map;

		map.on('load', () => {
			let destination_marker;
			const lnglatInput = document.getElementById('destination_lnglat_string');

			// marker highlighting dining item's lnglat
			const createDestinationMarker = (lnglat) => {
				const marker = new mapboxgl.Marker({ color: '#20bb43', scale: 1.5, draggable: true }).setLngLat(
					lnglat,
				);
				marker.on('dragend', (e) => {
					const lnglat = e.target._lngLat;
					const lnglatText = lnglat.lng + ',' + lnglat.lat;
					lnglatInput.value = lnglatText;
				});
				return marker;
			};

			// add a geojson feature and fill it with #c5050c
			// then pan the map to the lnglat
			const highlightMapObject = (geojson, lnglat) => {
				map.addSource('map-object-source', {
					type: 'geojson',
					data: geojson,
				});
				map.addLayer(
					{
						id: 'map-object-layer',
						type: 'fill',
						source: 'map-object-source',
						paint: {
							'fill-color': '#c5050c',
						},
					},
					'road-label',
				);
				map.panTo(lnglat);
			};

			// if the dining location has a map_object association
			// highlight it. I.e. when editing an existing record.
			if (W.map_object && W.map_object.geojson) {
				highlightMapObject(W.map_object.geojson, W.map_object.lnglat);
			}

			// Display the other dining locations for reference
			// TODO: we need to display destinations here; add a destinations_layer.js
			const url = W.api_root + 'destinations.geojson';
			if (!W.map.getSource('destinations-source')) {
				map.addSource('destinations-source', {
					type: 'geojson',
					data: url,
				});
			}
			map.addLayer({
				id: 'destinations-layer',
				type: 'symbol',
				source: 'destinations-source',
				layout: {
					'icon-image': 'location-dot-ababab',
					'icon-offset': [0, 0],
					'icon-anchor': 'bottom',
					'icon-size': 1.5,
					'icon-allow-overlap': true,
					'icon-ignore-placement': true,
				},
			});

			// filter out the current dining location from the layer
			if (W.destination) {
				map.setFilter('destinations-layer', ['!=', ['get', 'id'], W.destination.id]);
			}

			// if we're editing a dining location, create a marker for it
			// and add it to the map
			if (W.destination && W.destination.lnglat) {
				destination_marker = createDestinationMarker(W.destination.lnglat);
				destination_marker.addTo(map);
			}

			// update the destination's marker and the lnglat
			// input field in the form
			const updateLocation = (e) => {
				const lnglatText = e.lngLat.lng + ',' + e.lngLat.lat;
				if (destination_marker) {
					destination_marker.setLngLat(e.lngLat);
				} else {
					destination_marker = createDestinationMarker(e.lngLat);
					destination_marker.addTo(map);
				}
				lnglatInput.value = lnglatText;
			};
			map.on('click', updateLocation);

			const mapObjectsSelect = document.getElementById('destination_map_object_id');
			mapObjectsSelect.addEventListener('change', (e) => {
				const value = e.target.value;
				if (value) {
					// init our object and fetch its data from the API
					const map_object = new MapObject(value);
					map_object.fetch().then((mo) => {
						if (map.getLayer('map-object-layer')) {
							map.removeLayer('map-object-layer');
							map.removeSource('map-object-source');
						}
						highlightMapObject(mo.data.geojson, mo.data.lnglat);
					});
				}
			});
		});

		const mapObjectsSelect = document.getElementById('destination_map_object_id');
		if (mapObjectsSelect) {
			new TomSelect(mapObjectsSelect);
		}

		const tagSelect = document.getElementById('destination_tag_ids');
		if (tagSelect) {
			new TomSelect(tagSelect);
		}
	}
});
